module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2",
    attrs: {
      "id": "toc"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_vii"
    }
  }), _vm._v("Contents")]), _vm._v(" "), _c('p', {
    staticClass: "toc1b"
  }, [_c('em', [_c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/Preface"
    }
  }, [_vm._v("Preface")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/chapter1"
    }
  }, [_vm._v("1 Introduction: The Supreme Court before John Marshall")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('em', [_vm._v("Scott Douglas Gerber")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/chapter2"
    }
  }, [_vm._v("2 “Honour, Justice, and Interest”: John Jay’s Republican Politics and Statesmanship on the Federal Bench")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('em', [_vm._v("Sandra Frances VanBurkleo")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/chapter3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3 John Rutledge: Distinction and Declension")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('em', [_vm._v("James Haw")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/chapter4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4 Deconstructing William Cushing")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('em', [_vm._v("Scott Douglas Gerber")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/chapter5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5 James Wilson: Democratic Theorist and Supreme Court Justice")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('em', [_vm._v("Mark D. Hall")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/chapter6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6 John Blair: “A Safe and Conscientious Judge”")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('em', [_vm._v("Wythe Holt")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/chapter7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7 James Iredell: Revolutionist, Constitutionalist, Jurist")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('em', [_vm._v("Willis P. Whichard")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/chapter8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8 William Paterson: Small States’ Nationalist")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('em', [_vm._v("Daniel A. Degnan, S.J.")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/chapter9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9 The Verdict on Samuel Chase and His “Apologist”")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('em', [_vm._v("Stephen B. Presser")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "id": "page_viii"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/chapter10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10 Oliver Ellsworth: “I have sought the felicity and glory of your Administration”")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('em', [_vm._v("William R. Casto")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/chapter11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11 Heir Apparent: Bushrod Washington and Federal Justice in the Early Republic")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('em', [_vm._v("James R. Stoner, Jr.")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1a"
  }, [_c('em', [_c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/Editorsnote"
    }
  }, [_vm._v("Editor’s Note")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1a1"
  }, [_c('em', [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/Contributors",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Contributors")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1a1"
  }, [_c('em', [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/Index",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Index")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1a1"
  }, [_c('em', [_c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/AbouttheEditor"
    }
  }, [_vm._v("About the Editor")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-46c713f0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/content.vue
// module id = 72
// module chunks = 0